@let navigation = navigationWithAuthorization | async;
@for (nav of navigation; track nav.key) {
    <div
        class="nav-group"
        [class.selectedGroup]="urlComputed() === nav.route || selected() === nav.key"
        [class.exactSelect]="isNavSelected(nav)"
        [class.has-children]="nav.children && nav.children.length > 0"
        (click)="selected.set(nav.key)"
    >
        <a
            [routerLink]="nav.route"
            [class.selectedChild]="urlComputed() === nav.route"
            class="root"
            [class.linkInactive]="nav.route == null"
        >
            @if (nav.icon) {
                <mat-icon>
                    {{ nav.icon }}
                </mat-icon>
            }
            <span class="side-text">{{ nav.key | translate }}</span>
        </a>
        @if (nav.children !== undefined && selected() === nav.key) {
            @for (child of nav.children; track child.key) {
                <a
                    [routerLink]="child.route ?? child.key"
                    [class.selectedChild]="isNavSelected(child)"
                    class="children"
                    @expandHeight
                >
                    @if (child.icon) {
                        <mat-icon>
                            {{ child.icon }}
                        </mat-icon>
                    }
                    <span class="side-text">{{ child.key | translate }}</span>
                </a>
            }
        }
    </div>
}
